import React from 'react'
import { DisabledBannerOverlay } from 'components/atoms'
import RedirectButton from 'components/atoms/redirect-button'
import PropTypes from 'prop-types'

const propTypes = {
  banners: PropTypes.array
}

const defaultProps = {
  banners: []
}

const CmsLuxurySectionCarouselBanners = ({ banners }) => (
  <div className='text-center mt-3 mb-5'>
    {
      banners.map((section, index) => (
        <div
          key={ `${section.name}-${index}` }
          className='mx-2'
        >
          <DisabledBannerOverlay isActive={ section.is_active } />
          <img
            src={ section.image_url }
            alt={ section.alt_text }
            width='100%'
            style={ section.is_active ? {} : { filter: 'blur(3px)' } }
          />
          <RedirectButton
            className='mt-3'
            text={ `Edit ${section.name}` }
            path={ `sections/${section.id}` }
            color={ section.image_url && section.is_active ? 'primary' : 'warning' }
            size='sm'
          />
        </div>
      ))
    }
  </div>
)

CmsLuxurySectionCarouselBanners.propTypes    = propTypes
CmsLuxurySectionCarouselBanners.defaultProps = defaultProps

export default CmsLuxurySectionCarouselBanners
